/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'

export const useEffectWhen = (condition, effect, dependencies) => {
  useEffect(() => {
    if (condition) {
      const cleanupFunction = effect()

      if (cleanupFunction) {
        return () => cleanupFunction()
      }
    }
  }, [condition, ...dependencies])
}
